import { useMutation, useQuery } from '@tanstack/react-query';

import {
  getPromotions,
  getPromotion,
  createPromotion,
  updatePromotion,
  activatePromotion,
  deactivatePromotion,
  getTariffs,
} from '../../../../api';
import { PageParams } from '../../../../types/pagination';
import { PromotionRequest } from '../../../../types/promotion';

export const usePromotions = () => {
  return useMutation({ mutationFn: (params: PageParams) => getPromotions(params) });
};

export const useTariffs = () => {
  return useQuery({ queryKey: ['tariffs'], queryFn: getTariffs, staleTime: 5 * 60 * 1000 });
};

export const usePromotion = (id: number | undefined) => {
  return useQuery({
    queryKey: ['promotion', id],
    queryFn: () => getPromotion(id!),
    enabled: !!id,
    gcTime: 0,
    staleTime: 0,
  });
};

export const useCreatePromotion = () => {
  return useMutation({ mutationFn: (data: Omit<PromotionRequest, 'id'>) => createPromotion(data) });
};

export const useUpdatePromotion = () => {
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: PromotionRequest }) => updatePromotion(id, data),
  });
};

export const useActivatePromotion = () => {
  return useMutation({ mutationFn: (id: number) => activatePromotion(id) });
};

export const useDeactivatePromotion = () => {
  return useMutation({ mutationFn: (id: number) => deactivatePromotion(id) });
};
